import { styled } from '@mui/material';

import { useNavigate, useParams } from 'react-router';

import { FrameIcon } from '@app-velocity/icons';
import {
  Box,
  ButtonsContainer,
  InfoBox,
  RoundIcon,
  Button,
} from '@app-velocity/ui';
import { useI18n } from '@app-velocity/i18n';

import { useCurrentTeamPermissions } from '@app-velocity/libs/team-permissions';

import { AppraisalsRoutePaths } from '../../../../routes/AppraisalsRoutePaths';

const StyledBox = styled(Box)({
  textAlign: 'center',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  whiteSpace: 'pre-wrap',
  flex: 1,
});

export const NoAppraisals = () => {
  const { t } = useI18n();
  const { teamId, workspaceId } = useParams<{ teamId: string, workspaceId: string }>();
  const navigate = useNavigate();
  const currentTeam = useCurrentTeamPermissions();

  const goToNewPageReview = () => {
    if (!workspaceId || !teamId || !currentTeam) return;

    if (!currentTeam.canRunAppraisals()) {
      return;
    }

    navigate(AppraisalsRoutePaths.reviewAPage(teamId, workspaceId));
  };

  return (
    <StyledBox>
      <RoundIcon icon={<FrameIcon />} />
      <InfoBox
        title="appraisals:review_your_first.title"
        description="appraisals:review_your_first.title"
      />
      <ButtonsContainer>
        <Button variant="contained" color="primary" onClick={goToNewPageReview}>
          {t('appraisals:review_a_page')}
          <FrameIcon />
        </Button>
      </ButtonsContainer>
    </StyledBox>
  );
};
